import React from 'react'
import ManageItems from '../manage-form';
import ManageItemsBank from './manage-items-bank';

const ManageBank: React.FC = () => {
    return <ManageItemsBank title="Danh mục" />;
};

export default ManageBank
